import type { z } from "zod";
import { sendJson } from "@lib/http";
import type { preferencesPatchSchema } from "@lib/userPreferencesSchema";

/** The route that owns preference writes. Its schema types the body below. */
export const PREFERENCES_ENDPOINT = "/api/settings/preferences";

/** A preference patch body, typed by the schema the route validates it with. */
export type PreferencesPatch = z.input<typeof preferencesPatchSchema>;

/**
 * PATCH the preferences route. Returns the raw Response rather than throwing:
 * callers differ in how they report failure (a thrown error, a chip status, a
 * specific `same_locale` code read off the body), and only the request itself
 * is common to all of them.
 */
export function patchPreferences(patch: PreferencesPatch): Promise<Response> {
  return sendJson("PATCH", PREFERENCES_ENDPOINT, patch);
}
